var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4744 1.53847C5.36765 1.53847 2.03847 4.86765 2.03847 8.9744C2.03847 13.0812 5.36765 16.4103 9.4744 16.4103C11.4825 16.4103 13.3046 15.6144 14.6426 14.3207C14.6666 14.2873 14.6937 14.2553 14.7238 14.2253C14.7539 14.1952 14.7859 14.1681 14.8194 14.144C16.1138 12.8059 16.9103 10.9832 16.9103 8.9744C16.9103 4.86765 13.5812 1.53847 9.4744 1.53847ZM16.3403 14.7539C17.656 13.1925 18.4488 11.1761 18.4488 8.9744C18.4488 4.01798 14.4308 0 9.4744 0C4.51798 0 0.5 4.01798 0.5 8.9744C0.5 13.9308 4.51798 17.9488 9.4744 17.9488C11.6753 17.9488 13.6911 17.1566 15.2523 15.8417L19.1853 19.7747C19.4857 20.0751 19.9728 20.0751 20.2732 19.7747C20.5736 19.4743 20.5736 18.9872 20.2732 18.6868L16.3403 14.7539Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvSearchIcon);
export default __webpack_public_path__ + "static/media/cv-search-icon.f8b546f187b259f4a057b3e24ed3c18f.svg";
export { ForwardRef as ReactComponent };